import * as Api from '../../../api/Api';
import { useState } from 'react';
import PermissionsGate from '../../../api/PermissionsGate';
import { SCOPES } from '../../../config/permissions-map';
import { Unauthorized } from '../../Global/unauthorized';
import AgTable from '../../../Components/Table/AgTable';
import { useGetToken } from '../../../Hooks/CustomHooks';
import { PageTitle } from '../../../../_metronic/layout/core';
import DetalleEstadoCuenta from './DetalleEstadoCuenta';

export default function EstadoCuenta({ title }) {

    const [currentCuenta, setCurrentCuenta] = useState(null);
    const [viewDetalleEstadoCuenta, setViewDetalleEstadoCuenta] = useState(false);

    const token = useGetToken();

    let header = [
        {
            headerName: 'Razón Social',
            field: 'razonSocial',
        },
        {
            headerName: 'RUC',
            field: 'ruc',
        },
        {
            headerName: 'Ver Detalle',
            cellRenderer: (props) => (
                <button className="btn btn-light btn-active-light-primary btn-sm" onClick={
                    function () {
                        setCurrentCuenta(props.data);
                        setViewDetalleEstadoCuenta(true);
                    }
                } >
                    <i className="fi-rr-interactive"></i>
                </button >
            )
        }
    ];

    return (
        <>
            <PermissionsGate RenderError={() => <Unauthorized />} scopes={[SCOPES.ESTADO_CUENTA]} >
                {!viewDetalleEstadoCuenta ?
                    <>
                        <PageTitle>{title}</PageTitle>
                        <div className="card my-5">
                            <div className="card-body pt-6">
                                <AgTable
                                    idContent={"Esatdo Cuenta"}
                                    apiService={Api.EstadosCuentaLista}
                                    setAuxData={null}
                                    header={header}
                                    titleExcel={"Lista de Estado Cuenta"}
                                    conditions={true}
                                    args={{ token: token }}
                                    hideFilter={false}
                                    paginationPageSize={25}
                                    rowHeight={40}
                                    useFlex={false}
                                />
                            </div>
                        </div>
                    </> :
                    <>
                        <DetalleEstadoCuenta setViewDetalleEstadoCuenta={setViewDetalleEstadoCuenta} title={"Detalle del Estado de Cuenta"} currentCuenta={currentCuenta}></DetalleEstadoCuenta>
                    </>
                }


            </PermissionsGate>
        </>
    )
}